module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.formHtml) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formHtml)
    }
  }) : _vm._e()])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-48a4673b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/kind/Email.vue
 ** module id = 816
 ** module chunks = 1
 **/